import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { dispatcher } from 'dispatcher';
import { showLoginPopupAction } from 'js/components/popups/LoginPopup/store/actions';
import { EVENT_SHOW_LOGIN_POPUP } from 'js/components/popups/LoginPopup/buzz/constants';

export const useListenShowLoginPopup = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const showLoginPopup = popupData => dispatch(showLoginPopupAction(popupData));

        dispatcher.listen(EVENT_SHOW_LOGIN_POPUP, showLoginPopup);

        return () => {
            dispatcher.removeListener(EVENT_SHOW_LOGIN_POPUP, showLoginPopup);
        };
    }, [dispatch]);
};
